import { render, staticRenderFns } from "./reserve-record-communicate-dialog.vue?vue&type=template&id=1f7f2d44&scoped=true"
import script from "./reserve-record-communicate-dialog.vue?vue&type=script&lang=js"
export * from "./reserve-record-communicate-dialog.vue?vue&type=script&lang=js"
import style0 from "./reserve-record-communicate-dialog.vue?vue&type=style&index=0&id=1f7f2d44&prod&scoped=true&lang=css"
import style1 from "./reserve-record-communicate-dialog.vue?vue&type=style&index=1&id=1f7f2d44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7f2d44",
  null
  
)

export default component.exports